import React, { useState, useEffect } from 'react';
import { Typography, Box, makeStyles } from '@material-ui/core';
import { withNamespaces, Trans } from 'react-i18next';
import { CSSTransition } from 'react-transition-group';
import Vintage from '../../../../../components/images/vintage04.png';

import { StraightStripes } from '../../../../../components/icons';

const useStyles = makeStyles((theme) => ({
	imageContainer: {
		position: 'absolute',
		background: `transparent url(${Vintage}) 0% 0% no-repeat padding-box`,
		mixBlendMode: 'multiply',
		backgroundSize: 'cover',
		width: '100%',
		height: '100%'
	},
	imageContainerFixed: {
		position: 'absolute',
		backgroundColor: '#DDE9E6',
		width: 807,
		height: 608,
		top: 82,
		right: -40,

		[theme.breakpoints.only('xs')]: {
			width: 300,
			top: 0,
			right: 0,
			left: 'auto',
			height: 200
		},
		[theme.breakpoints.only('md')]: {
			width: 600,
			top: 230,
			right: 0,
			left: 'auto',
			height: 430
		},
		[theme.breakpoints.only('lg')]: {
			top: 0
		},
		[theme.breakpoints.only('sm')]: {
			width: 600,
			top: -100,
			right: 0,
			left: 'auto',
			height: 430
		}
	},
	pageContainer: {
		position: 'fixed',
		[theme.breakpoints.down('md')]: {
			position: 'absolute',
			height: '100%'
		},
		width: 1215,
		marginLeft: 'auto',
		marginRight: 'auto',
		right: 0,
		left: 0,
		top: 129,
		[theme.breakpoints.only('xs')]: {
			top: 50,
			width: '100%'
		},
		[theme.breakpoints.down('md')]: {
			position: 'absolute',
			width: '100%'
		},
		[theme.breakpoints.only('xl')]: {
			top: 200
		}
	},
	mainTitleBox: {
		top: 52,
		position: 'absolute',
		background: theme.palette.primary.dark,
		left: 214,
		textAlign: 'left',
		zIndex: 101,
		[theme.breakpoints.only('xs')]: {
			left: 30,
			top: 170
		},
		[theme.breakpoints.only('sm')]: {
			left: 100
		}
	},
	mainTitleText: {
		fontFamily: 'Bebas Neue',
		color: '#E0B080',
		fontSize: '30px',
		letterSpacing: '0.30px',
		lineHeight: '30px',
		marginTop: 19,
		marginRight: 86,
		marginBottom: 11,
		marginLeft: 86,
		[theme.breakpoints.only('xs')]: {
			marginTop: 7,
			marginRight: 20,
			marginBottom: 3,
			marginLeft: 20,
			fontSize: 30,
			lineHeight: '30px',
			letterSpacing: '2px'
		}
	},
	halfStripes: {
		top: 0,
		left: 164,
		position: 'absolute',
		zIndex: 100,
		width: '400px',
		height: '252px',
		[theme.breakpoints.only('xs')]: {
			width: 300,
			left: 0,
			opacity: 0.5
		}
	},
	descriptionContainer: {
		position: 'absolute',
		top: 292,
		width: 480,
		left: 0,
		[theme.breakpoints.only('xs')]: {
			width: '100%',
			top: 240
		},
		[theme.breakpoints.only('md')]: {
			left: 30
		},
		[theme.breakpoints.only('sm')]: {
			top: 400,
			width: '100%'
		}
	},
	descriptionText: {
		textAlign: 'left',
		letterSpacing: '0.18px',
		fontSize: '18px',
		lineHeight: '30px',
		flexWrap: 'wrap',
		fontWeight: 'bold',
		[theme.breakpoints.only('xs')]: {
			fontSize: 16,
			marginLeft: 30,
			marginRight: 10
		},
		[theme.breakpoints.only('sm')]: {
			paddingLeft: 40,
			paddingRight: 40
		}
	}
}));

function MadefalvaHistory2(props) {
	const classes = useStyles();
	const { t } = props;
	const [showAnimation, setShowAnimation] = useState(props.showAnimation);
	useEffect(() => {
		if (props.showAnimation) {
			const timeOut = setTimeout(() => {
				setShowAnimation(props.showAnimation);
			}, 300);
			return () => clearTimeout(timeOut);
		}
		setShowAnimation(props.showAnimation);
	}, [props.showAnimation]);

	return (
		<Box className={classes.pageContainer}>
			<CSSTransition
				in={showAnimation}
				timeout={300}
				classNames='vintageimage'
				unmountOnExit>
				<Box className={classes.imageContainerFixed}>
					<Box className={classes.imageContainer} />
				</Box>
			</CSSTransition>
			<CSSTransition
				in={showAnimation}
				timeout={300}
				classNames='rtllong'
				unmountOnExit>
				<Box className={classes.mainTitleBox}>
					<Typography className={classes.mainTitleText}>
						{t('madehistory2.maintitle')}
					</Typography>
				</Box>
			</CSSTransition>
			<CSSTransition
				in={showAnimation}
				timeout={300}
				classNames='bttmiddle'
				unmountOnExit>
				<Box className={classes.descriptionContainer}>
					<Typography className={classes.descriptionText}>
						<Trans i18nKey='madehistory2.description'>
							<br />
							<br />
						</Trans>
					</Typography>
				</Box>
			</CSSTransition>
			<CSSTransition
				in={showAnimation}
				timeout={300}
				classNames='rtllong'
				unmountOnExit>
				<Box className={classes.halfStripes}>
					<StraightStripes width='100%' height='100%' />
				</Box>
			</CSSTransition>
		</Box>
	);
}

export default withNamespaces('madefalvaHistory')(MadefalvaHistory2);
